import { useRef, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import qs from 'qs';
import { ToastContainer, toast } from "react-toastify";


const BVNModal = () => {

    const [accessToken, setAccessToken] = useState("")
    const navigate = useNavigate()

    const verifyResults = (verificationId) => {
        const username = '654e61e419e1f9001cb85ff6';
        const password = 'CIO5KWKMU2TI5WMJMNDVRGVDH3LVEFZA';
                      
        const credentials = btoa(`${username}:${password}`);
        const authHeader = `Basic ${credentials}`;

        const apiUrl = 'https://api.getmati.com/oauth'; // Replace with your API endpoint
        const verificationUrl = ''

        const data = {
            grant_type: 'client_credentials',
            username: username,
            password: password,
        };

        axios.post(apiUrl, qs.stringify(data), {
            headers: {
                'Authorization': authHeader,
                'Content-Type': 'application/x-www-form-urlencoded',
                // Add other headers as needed
            },
        })
            .then(response => {
                // Handle the response
                console.log(response.data.access_token);
                setAccessToken(response.data.access_token)
                const rToken = response.data.access_token
                //make second axios request to verification endpoint.

                axios.get('https://api.getmati.com/v2/verifications/' + verificationId, {
                    headers: {
                        'Authorization': `Bearer ${rToken}`,
                        'Content-Type': 'application/json',
                        // Add other headers as needed
                    },
                })
                    .then(response => {
                        // Handle the response
                        console.log(response.data.steps);
                        console.log(response.data.hasProblem)
                        const problem = response.data.hasProblem
                        const userData = response.data.steps[0].data
                        console.log(userData)

                        if (problem === true) {
                            toast.error("Your BVN Verification Failed. Please Make sure the BVN number and details are correct and try again", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        }
                        else if (problem === false){
                            toast.success("Your BVN Verification was successful, routing you to onboarding form", {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });

                            //save details to local storage.
                            const firstname = response.data.steps[0].data.firstName
                            const lastname = response.data.steps[0].data.lastName
                            const bvn = response.data.steps[0].data.bvn
                            const dob = response.data.steps[0].data.dateOfBirth
                            const gender = response.data.steps[0].data.bvn

                            const individualData ={
                                "firstname":firstname,
                                "lastname":lastname,
                                "bvn":bvn,
                                "dob":dob,
                            }

                            sessionStorage.setItem("individualData",JSON.stringify(individualData))
                            console.log(bvn+" "+firstname+" "+lastname)

                            setTimeout(()=>navigate("/new-individual-account"), 3000)
                        }

                    })
                    .catch(error => {
                        // Handle errors
                        console.error('Error:', error);

                    })
                    .finally(() => {
                        console.log("verification completed")
                    })
            })
            .catch(error => {
                // Handle errors
                console.error('Error:', error);
            })
            .finally(() => {
                console.log("token aquired")
            });
    }

    // useEffect(() => {
    //     verifyResults('6555ec50b7b782001c0ac56e')

    // },[]);


    const button = useRef(null);
    const [clientid] = useState('654e61e419e1f9001cb85ff6');
    const [flowid] = useState('6554d20a1fc59f001c19c9be');


    useEffect(() => {
        if (button.current) {
            button.current.addEventListener('metamap:loaded', ({ detail }) => console.log('[METAMAP] Loaded', detail));
            button.current.addEventListener('metamap:userStartedSdk', ({ detail }) => console.log('[METAMAP] User started verification', detail));

            // Handle event when user finished verification
            button.current.addEventListener('metamap:userFinishedSdk', ({ detail }) => {
                console.log('[METAMAP] User finished verification', detail)
                console.log(detail)
                verifyResults(detail.verificationId)
            });

            // Handle event when user exits verification
            button.current.addEventListener('metamap:exitedSdk', ({ detail }) => {
                console.log('[METAMAP] User exited verification', detail)
                console.log(detail)
                // verifyResults(detail.verificationId)
            });
        }
    }, [button]);

    return (
        <div className="modal fade" id="bvn-verification">
            <div className="modal-dialog modal-sm">
                <div className="modal-content radius-3">

                    {/* <!-- Modal Header --> */}
                    <div className="modal-header">
                        <h6 className="modal-title"><i className="bi-shield me-2"></i> BVN Verification</h6>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    {/* <!-- Modal body --> */}
                    <div className="modal-body">
                        <div className="">

                            <h6 className="bold">Account Auth</h6>
                            <p className="text-small text-muted">Take the initial step in completing your account onboarding by verifying your BVN.</p>
                            <metamap-button
                                ref={button}
                                clientid={clientid}
                                flowid={flowid}
                                className="btn-custom"
                                style={{width:"100%"}}
                                data-bs-dismiss="modal"
                            >
                            </metamap-button>
                            <div className="p-3 bg-silver-gradient mt-3" style={{ fontSize: "11px" }}>
                                Your BVN and verification details are kept secure and confidential. We prioritize data protection and will not share your information.
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default BVNModal